import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { browserPushUrl } from '@/utils';
import { GlobalTracker, SearchTracker } from '@/utils/Tracker';
import Item from './components/Item';
import ServiceItem from './components/Item/ServiceItem';
import CustomSkinItem from './components/Item/CustomSkinItem';
import styles from './index.module.less';
import cls from 'classnames';
import { checkIsSearchResultsPage } from 'src/pages/search/utils';

@inject('area', 'order', 'meta', 'app')
@observer
class PopCartList extends Component {
  loadedCartDetail = false;

  handleLoadCartDetail = () => {
    const { isOrderConfirmPage, isCartPage } = this.props.app;
    if (isOrderConfirmPage || isCartPage) return;

    if (this.loadedCartDetail) return;
    this.loadedCartDetail = true;
    this.props.order.loadAllCartDetail();
  };

  onClickBtn = () => {
    GlobalTracker.navigation({ action: 'click_cart' });
    browserPushUrl('/cart?from=nav');
  };

  render() {
    const { popupCartListVisible } = this.props.meta;
    const { campaignWrap } = this.props.app;
    const { containerClassName, popupClassName } = this.props;
    const {
      order: { ShoppingCartAllItems, selectedCartItems },
      area: { LANG },
      isDarkBg = false,
    } = this.props;
    const list = ShoppingCartAllItems.slice(0, 2);
    const restLength = ShoppingCartAllItems.length - 2 > 0 ? ShoppingCartAllItems.length - 2 : 0;
    const isEmpty = !ShoppingCartAllItems[0];

    // 弹窗展示的时候也调用加载方法
    if (popupCartListVisible) {
      this.handleLoadCartDetail();
    }
    return (
      <div
        id='popupCartList'
        className={cls(styles.popup, popupClassName)}
        data-dark-bg={isDarkBg}
        data-visible={popupCartListVisible}
      >
        <div className={styles.wrap}>
          <div className={cls([styles.container, containerClassName])}>
            {isEmpty && <div className={styles.empty}>{LANG['cart.emptyTips']}</div>}
            {!isEmpty && (
              <div>
                <div className={styles.list}>
                  {list.map((item, key) => {
                    if (item.customType) return <CustomSkinItem key={key} item={item} />;
                    if (item.isBindServices) return <ServiceItem key={key} item={item} count={item.count} />;
                    return <Item key={key} item={item} />;
                  })}
                </div>

                {restLength > 1 && (
                  <div className={styles.t}>
                    {LANG['navigation.cartItemsLength'].replace('__quantity__', restLength)}
                  </div>
                )}
                {restLength === 1 && <div className={styles.t}>{LANG['navigation.cartItem1']}</div>}
                {campaignWrap?.getCartCardText?.(selectedCartItems, ShoppingCartAllItems)}
                <div className={styles.checkout}>
                  <a
                    className={styles.btn}
                    href='/cart?from=top_bar'
                    onClick={() => {
                      GlobalTracker.navigation({ action: 'cart_pop_checkout' });

                      // 搜索结果页的购物车曝光
                      if (checkIsSearchResultsPage()) {
                        SearchTracker.searchResultsPageTracing({
                          action: 'cart_pop_checkout',
                          label: 'search_result_page',
                        });
                      }
                    }}
                  >
                    {LANG['navigation.toCart']}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PopCartList;
